export class StatoApplicazioneDTO {
  manutenzione: boolean;
  messaggio: string;
  dataInizioManutenzione: string;
  statoElementi: Map<string, string> = new Map<string, string>();
}
